module.exports = {"222404001":"靖和街道","222404002":"新安街道","222404003":"河南街道","222404060":"近海街道","222404100":"春化镇","222404101":"敬信镇","222404102":"板石镇","222404103":"英安镇","222404200":"马川子乡","222404201":"杨泡满族乡","222404202":"三家子满族乡","222404203":"密江乡","222404204":"哈达门乡","222404400":"珲春林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/222404.json
// module id = 610
// module chunks = 0